module.exports = __webpack_public_path__ + "media/images/wines/magnum/bottle-detail-25139d55c559323a16dbad8fdfec54c6.png";